<div *ngIf="isOpen" class="chat-panel-wrapper">
  <div class="triangle"></div>
  <div class="header">
    <div class="title">{{ 'label.chat.active_chat_title' | translate }}</div>
    <div class="x-close" (click)="closePanel()">
      <i class="bi bi-x"></i>
    </div>
  </div>
  <div class="content">
    <div class="no-items-global" *ngIf="!chatService.activeChats.length">{{ 'label.chat.no_active_chat' | translate }}</div>
    <div class="notifications">
      <div class="notification" (click)="navigateToCase(chat)" *ngFor="let chat of chatService.activeChats.slice().reverse()">
        <span>{{ 'label.chat.active_chat_notification' | translate }} </span><span class="ticket-name">{{ 'label.chat.title' | translate: { caseId: chat.chatRoomName } }}</span>
      </div>
    </div>
  </div>
</div>
